import { lory } from '@rsm/allfarblori';

export default class Gallery {
  constructor($el, options) {
    this.$el = $el;
    this.$slidesFrame = this.$el.querySelector('.gallery__slides-frame');
    this.$slidesContainer = this.$el.querySelector('.gallery__slider');
    this.$slides = this.$el.querySelectorAll('.gallery__slider-item');
    this.$galleryButton = this.$el.querySelector('.gallery__button');
    this.$galleryButtonText = this.$galleryButton.querySelector('.button__text');

    // Bring in the options
    this.options = {
      ...options,
    };

    // Don't init slider, if only one slide exists
    if (this.$slides.length === 1) {
      return;
    }

    this.constructGallery();
  }

  deconstructor() {
    if (this.lory) {
      this.lory.destroy();
    }
  }

  constructGallery() {
    this.$el.addEventListener('before.lory.init', () => {
      this.$slidesContainer.scrollLeft = 0;
    });

    this.$el.addEventListener('after.lory.init', () => {
      this.$el.classList.add('slider--initialized');
      this.$galleryButtonText.innerHTML = `${this.$slides.length} Bilder`;
    });

    this.lory = lory(this.$el, {
      rewind: true,
      rewindPrev: true,
      rewindSpeed: 200,
      slideSpeed: 350,
      ease: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      classNameFrame: 'gallery__slides-frame',
      classNameSlideContainer: 'gallery__slider',
    });
  }
}

// Trigger Gallery by Breakpoint
const mql = [
  window.matchMedia('(min-width: 480px)'),
  window.matchMedia('(min-width: 768px)'),
  window.matchMedia('(min-width: 1203px)'),
];

let componentStore = [];

export function onMediaQueryChange() {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];

  document
    .querySelectorAll('.gallery')
    .forEach(($gallery) => {
      componentStore.push(new Gallery($gallery, {
        sizerTarget: 'figure__media',
      }));

      // eslint-disable-next-line func-names
      $gallery.querySelector('.gallery__button').addEventListener('click', function () {
        const groupId = this.getAttribute('data-lightbox-group');
        let $lightboxEl;
        if (groupId) {
          $lightboxEl = document.querySelector(`.gallery__slider-item .js-lightbox[data-lightbox-group="${groupId}"]`);
        } else {
          $lightboxEl = document.querySelector('.gallery__slider-item .js-lightbox');
        }
        const evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        $lightboxEl.dispatchEvent(evt);
      });
    });
}

mql.forEach(((el) => {
  el.addListener(onMediaQueryChange);
}));

document.addEventListener('DOMContentLoaded', () => {
  onMediaQueryChange();
}, false);
